module.exports = __webpack_public_path__ + "img/step07_c_stand_power_bottom_cross_fix_screws_right_foot.f3be4690.png";